import { Box, Link, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PhoneIcon from '@mui/icons-material/Phone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const CenteredFlex = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const PhoneIconWithSpacer = styled(PhoneIcon)({
  marginRight: '10px',
});

const MailOutlineIconWithSpacer = styled(MailOutlineIcon)({
  marginRight: '10px',
});

export const ContactEmail = () => {
  return (
    <CenteredFlex>
      <MailOutlineIconWithSpacer />
      <Link
        href={`mailto:onvista-cashback@rentablo.de`}
        variant="subtitle2"
        color="secondary"
        underline="hover"
      >
        <strong>onvista-cashback@rentablo.de</strong>
      </Link>
    </CenteredFlex>
  );
};

export const ContactPhone = () => {
  const { t } = useTranslation();
  return (
    <CenteredFlex>
      <PhoneIconWithSpacer />
      <Box lineHeight={1}>
        <Link
          variant="subtitle2"
          href={`tel:${t('customerService.phoneLink')}`}
          color="secondary"
          underline="hover"
        >
          <strong>{t('customerService.phone')}</strong>
        </Link>
        <Typography variant="body2">Mo.-Fr. 9-19 Uhr</Typography>
      </Box>
    </CenteredFlex>
  );
};
